/**
 * Leave a screen that was opened with `getPushNavigationUpdate` (e.g. quote/cart finalize) without
 * breaking the navigation stack. `getNavigationUpdate(Summary)` replaces the current state and clears
 * stack history, so the sidebar back button disappears on Summary (`hasStackToPop` becomes false).
 */
export function commitPopOrNavigateToSummary<TState, TNav, TUpdate>(
  navigationSystem: {
    getPopNavigationUpdate: (state: TState) => TUpdate | null | undefined
    getNavigationUpdate: (activeState: TNav) => TUpdate
  },
  storeSystem: {
    stateSlices: { committed: { value: { state: TState } } }
    stageAndCommit: (updates: readonly TUpdate[]) => void
  },
  /** Used only when the stack is empty (e.g. broken history). */
  fallbackNavigationState: TNav
): void {
  const state = storeSystem.stateSlices.committed.value.state
  const popUpdate = navigationSystem.getPopNavigationUpdate(state)
  if (popUpdate) {
    storeSystem.stageAndCommit([popUpdate])
  } else {
    storeSystem.stageAndCommit([navigationSystem.getNavigationUpdate(fallbackNavigationState)])
  }
}
